/**
 * Strips `singleExactPay` from a virtual-card payload when the request is
 * a bill-pay submission and the bill-pay Exact Pay rollout flag is off.
 *
 * Shared by the create and update payload builders so the same defensive
 * scrub applies on both paths — prevents a stale `true` from leaking into
 * a non-BMO bill-pay POST if the flag is flipped off after a card was set
 * up.
 */

export interface ScrubSingleExactPayArgs {
  isBillPay: boolean | undefined
  billPayExactPayEnabled: boolean | undefined
  value: boolean | undefined
}

export function scrubSingleExactPayForBillPay(
  args: ScrubSingleExactPayArgs,
): boolean | undefined {
  if (args.isBillPay && !args.billPayExactPayEnabled) return undefined
  return args.value
}
